import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'Bomb',
  description: 'Bomb',
  image: '',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  switch (path) {
    case '/':
      return {
        title: `${t('Home')} | ${t('Bomb')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('Bomb')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('Bomb')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('Bomb')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('Bomb')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('Bomb')}`,
      }
    case '/collectibles':
      return {
        title: `${t('Collectibles')} | ${t('Bomb')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('Bomb')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('Bomb')}`,
      }
    case '/profile/tasks':
      return {
        title: `${t('Task Center')} | ${t('Bomb')}`,
      }
    case '/profile':
      return {
        title: `${t('Your Profile')} | ${t('Bomb')}`,
      }
    default:
      return null
  }
}
